import { z } from 'zod'
import { UuidSchema } from '../../../utils/zodUuid'
import type { ActOnApprovalOptionInput } from './approvalActions'
import { ConfiguredFieldValuesInputSchema } from './configuredFieldSchemas'

const ApprovalActionTypeSchema = z.enum(['approved', 'rejected', 'cleared'])

/**
 * Validates the fixed shape of an approval-action mutation request.
 *
 * Whether a note and each dynamic field value are permitted is intentionally
 * checked after the server reloads the current locked action configuration.
 */
export const ActOnApprovalOptionInputSchema = z
  .object({
    action: ApprovalActionTypeSchema,
    note: z.string().nullable().optional(),
    optionId: UuidSchema,
    recordId: UuidSchema,
    values: ConfiguredFieldValuesInputSchema,
  })
  .strict() satisfies z.ZodType<ActOnApprovalOptionInput>
